import React, { useState } from "react";
import {
    IoClose,
    IoSend,
    IoImage,
    IoMic,
    IoLocationSharp,
    IoHappyOutline,
  } from "react-icons/io5";


function ConversationDetail({ chat,handleProfileClick }) {
    const [message,setMessage]=useState("");
    console.log("chat",chat);
    
  return (
    <div className="h-[100%]">
      
      <div className="border flex items-center rounded-lg p-4 mt-2 cursor-pointer"
    //   onClick={}
      >
        <img className="w-1 h-12 rounded-full mr-2" src={chat.avatar} alt="" 
        onClick={handleProfileClick}/>
        <div className="">
        <p 
        onClick={handleProfileClick}
        className="font-semibold text-lg">{chat?.name}</p>
        {chat?.online_status?<p className="text-sm text-green500">online</p>:<p className="text-RedColor text-sm">offline</p>}
        </div>
      </div>
     <div className="border h-[70%]">
     {chat?.message.map((msg, index) => (
    <div
      key={index}
    //   onClick={() => onChatClick(msg)}
      className="cursor-pointer gap-2 p-2 mb-2 border-gray-300 rounded hover:bg-gray-100"
    >
    
    <div className=" flex justify-start ">
        <p className=" bg-[#18202c] text-white p-2 m-2 rounded-lg">{msg.user}</p>
    </div>
    <div className=" flex justify-end ">
        <p className="bg-[#00796b] text-white p-2 m-2 rounded-lg">{msg.me}</p>
    </div>
    </div>
  ))}
     </div>
  {/* Input Area */}
  <div className="p-2 pt-6 pl-2  border-t bg-gray-100 flex items-center space-x-3">
        <button className="text-[#6B7280] hover:text-blue500">
          <IoMic size={24} />
        </button>
        <div className="flex-1 relative">
          <input
            type="text"
            placeholder="Type a message"
            className="w-full rounded-full border border-gray-300 bg-white px-4 py-2 pl-10 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue500"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
          <IoHappyOutline
            size={20}
            className="absolute top-1/2 transform -translate-y-1/2 left-3 text-gray-400"
          />
        </div>
        <button className="text-[#6B7280] hover:text-blue500">
          <IoImage size={24} />
        </button>
        <button className="text-[#6B7280] hover:text-blue500">
          <IoLocationSharp size={24} />
        </button>
        <button
          className="text-RedColor hover:text-blue700"
        //   onClick={handleMessage}
        >
          <IoSend size={24} />
        </button>
      </div>
    </div>
  );
}
export default ConversationDetail;
